import Vue from 'vue'
import Router from 'vue-router'
import VueCookies from 'vue-cookies'

import Customers from '../screens/Customers'
import Engines from '../screens/Engines'
import Subsystems from '../screens/Subsystems'
import Login from '../screens/Login'


import {store} from "../main.js"

Vue.use(Router);
Vue.use(VueCookies);

var router = new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            beforeEnter: (to, from, next) => {
                const {uri} = to.query;
                if (uri != null && uri != '/') {
                    next(false);
                    router.push(uri);
                } else {
                    next();
                }
            },
            redirect: {name: "Login"}
        },
        {
            path: '/engines/:eng?',
            name: 'Engines',
            component: Engines
        },
        {
            path: '/subsystems/:sys?',
            name: 'Subsystems',
            component: Subsystems
        },
        {
            path: '/customers/:company?',
            name: 'Customers',
            component: Customers
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.path == '/login') {
        if (window.$cookies.isKey('user'))
            next('/engines');
        else
            next();
    } else {
        if (!window.$cookies.isKey('user'))
            next('/login');
        else
            next();
    }
});


export default router;




